import { render, staticRenderFns } from "./OrganizationTokens.vue?vue&type=template&id=3a0158d2"
import script from "./OrganizationTokens.vue?vue&type=script&lang=js"
export * from "./OrganizationTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports